(function () {
    'use strict';


    angular.module('app')
        .run(run);

    function run($rootScope, $location,$uibModalStack) {


        $rootScope.$on('$routeChangeStart', function (event, current) {

            $('#taishinExternal').empty().remove();
            $('#captcha iframe').empty().remove();


            // 如果登入後到 login 頁需要轉到預設頁面
            // 是參考 taiHeader.directive 的判斷登入邏輯
            let isLogin = !_.isEmpty(sessionStorage.getItem('perSerilNo')) && !sessionStorage.getItem('isForce');
            var currentPage = current.originalPath;
            if (currentPage === '/login' && isLogin) {
                $location.path('/').search({});
            }

        });

        $rootScope.$on('$routeChangeSuccess', function (event, current) {
            
            // When the user clicks on the button, scroll to the top of the document
            document.body.scrollTop = 0; // For Chrome, Safari and Opera 
            document.documentElement.scrollTop = 0; // For IE and Firefox


            $(".ui-blackCover").css("display","none");

            // 移除目前所有 modal 視窗 (避免殘存) 
            $uibModalStack.dismissAll();

            // 解決表單有時在IE無法輸入問題
            fixIeNotAbleToInput();

            var isForce = sessionStorage.getItem('isForce');
            var currentPage = current.originalPath;
            //var prevPage = prev ? prev.originalPath : null;
            $rootScope.cName = sessionStorage.getItem('cName');

            if (isForce) {
                $location.path('/login/forceEditPwd');
            } else {
                if (currentPage === '/login/forceEditPwd' && !isForce) {
                    $location.path('/login');
                }
            }

            if (currentPage === '/' && !sessionStorage.getItem('token')) {
                $location.path('/login').search({});
            }

        });
    }
})();